import { differenceInCalendarDays, format, parseISO } from "date-fns";
import { nl } from "date-fns/locale";

// Vaste referentie-"vandaag" voor de prototype, zodat de dashboard-signalen
// (CB-41) deterministisch zijn los van de echte systeemklok. Ligt in de
// seed-periode (juni 2026).
export const TODAY = "2026-06-29";

// Aantal kalenderdagen vanaf TODAY tot de gegeven datum (negatief = verleden).
export function daysUntil(iso: string): number {
  return differenceInCalendarDays(parseISO(iso), parseISO(TODAY));
}

export function formatDate(iso: string | undefined): string {
  if (!iso) return "-";
  return format(parseISO(iso), "dd/MM/yyyy", { locale: nl });
}

export function formatDateTime(iso: string | undefined): string {
  if (!iso) return "-";
  return format(parseISO(iso), "dd/MM/yyyy HH:mm", { locale: nl });
}

export function formatPeriod(startIso: string, endIso: string): string {
  return `${formatDate(startIso)} → ${formatDate(endIso)}`;
}

export function fullName(firstName: string, lastName: string): string {
  return `${firstName} ${lastName}`.trim();
}
